var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6735 17.5C56.092 18.167 59.2338 19.8389 61.6967 22.3018C64.1596 24.7646 65.8315 27.9064 66.4985 31.325M52.6735 3.5C59.7759 4.28903 66.399 7.46961 71.4553 12.5195C76.5116 17.5694 79.7005 24.1885 80.4984 31.29M76.9984 59.22V69.72C77.0024 70.6948 76.8027 71.6596 76.4122 72.5527C76.0217 73.4458 75.449 74.2476 74.7307 74.9065C74.0124 75.5655 73.1645 76.0672 72.2411 76.3795C71.3177 76.6918 70.3393 76.8077 69.3684 76.72C58.5984 75.5497 48.2529 71.8695 39.1635 65.975C30.7068 60.6013 23.5371 53.4316 18.1635 44.975C12.2484 35.8442 8.5673 25.4485 7.41845 14.63C7.33099 13.6621 7.44602 12.6867 7.75621 11.7657C8.06639 10.8447 8.56495 9.99841 9.22013 9.28067C9.87532 8.56294 10.6728 7.98948 11.5617 7.59683C12.4507 7.20417 13.4116 7.00092 14.3835 7H24.8835C26.582 6.98328 28.2287 7.58478 29.5166 8.69236C30.8045 9.79995 31.6457 11.3381 31.8835 13.02C32.3266 16.3802 33.1485 19.6795 34.3335 22.855C34.8044 24.1077 34.9063 25.4692 34.6271 26.7781C34.348 28.087 33.6995 29.2884 32.7585 30.24L28.3135 34.685C33.2959 43.4474 40.551 50.7026 49.3135 55.685L53.7584 51.24C54.7101 50.299 55.9115 49.6505 57.2204 49.3713C58.5292 49.0922 59.8907 49.1941 61.1434 49.665C64.3189 50.8499 67.6182 51.6718 70.9785 52.115C72.6786 52.3549 74.2314 53.2112 75.3413 54.5212C76.4513 55.8312 77.041 57.5035 76.9984 59.22Z",
    stroke: "#767676",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.3091531591785d1e7f60eb6e4f8c193d.svg";
export { ForwardRef as ReactComponent };